import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { EmploiDuTempsPrint } from '@teetsh/app/src/types/edt';
import { edtDeserializer } from '@teetsh/app/src/queries/edt/serializer';
import { Classroom } from '@teetsh/app/src/types/classroom';

function fetchEDTPrint({
  schoolyearId,
  schoolId,
  edtId,
}: {
  schoolyearId: string;
  schoolId: string;
  edtId: string;
}) {
  const requestURL = `/print/schoolyears/${schoolyearId}/schools/${schoolId}/emplois-du-temps/${edtId}`;
  return request(requestURL, {
    method: 'GET',
  }).then<{ edt: EmploiDuTempsPrint; classrooms: Classroom[] }>(p => ({
    ...p,
    edt: edtDeserializer(p.edt, p.tz),
  }));
}

interface Props {
  edtId: string;
  schoolyearId: string;
  schoolId: string;
}

export default function useEDTPrint({ edtId, schoolyearId, schoolId }: Props) {
  return useQuery({
    queryKey: [schoolyearId, schoolId, edtId, 'printEDT'],
    queryFn: () =>
      fetchEDTPrint({
        schoolyearId: schoolyearId,
        schoolId: schoolId,
        edtId,
      }),

    staleTime: 60 * 1000 * 60,
    refetchOnWindowFocus: false,
  });
}
